import { Fragment } from 'react';
import { Separator, Text } from '@frameio/vapor';
import styles from './ExportSettingsMetadata.module.css';

type ExportSettingsMetadataProps = {
  metadata: { key: string; value: string | number }[];
};

export const ExportSettingsMetadata = ({
  metadata,
}: ExportSettingsMetadataProps) => {
  return (
    <div className={styles.container}>
      {metadata.length > 0 && (
        <div className={styles.items}>
          {metadata.map(({ key, value }, index) => (
            <Fragment key={key}>
              <Text color="tertiary" variant="caption">
                {value}
              </Text>
              {index < metadata.length - 1 && (
                <Separator color="tertiary" vertical={true} />
              )}
            </Fragment>
          ))}
        </div>
      )}
    </div>
  );
};
